const ITEM_TEXT_CLAMP_HEIGHT = 60;

function setupItemTextToggles(container) {
  const textEls = container.querySelectorAll('.item__text');
  textEls.forEach((textEl) => {
    const toggleBtn = textEl.nextElementSibling;
    if (!toggleBtn || !toggleBtn.hasAttribute('data-item-text-toggle')) return;

    toggleBtn.hidden = textEl.scrollHeight <= ITEM_TEXT_CLAMP_HEIGHT;
  });
}

function onItemTextToggleClick(event) {
  const toggleBtn = event.target.closest('[data-item-text-toggle]');
  if (!toggleBtn) return;

  const textEl = toggleBtn.previousElementSibling;
  if (!textEl) return;

  const expanded = textEl.classList.toggle('item__text--expanded');
  toggleBtn.setAttribute('aria-expanded', expanded);
  toggleBtn.textContent = expanded ? toggleBtn.dataset.lessText : toggleBtn.dataset.moreText;
}

const productLayering = document.querySelector('product-layering');
if (productLayering) {
  productLayering.addEventListener('click', onItemTextToggleClick);

  const productLayeringSlider = productLayering.querySelector('.product-layering__slider');
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  // Pre-clone slides on mobile so BlazeSlider has enough real slides to loop
  // smoothly without a visible snap-back jump.
  if (productLayeringSlider && mobileQuery.matches) {
    const blazeTrack = productLayeringSlider.querySelector('.blaze-track');
    if (blazeTrack) {
      const originals = [...blazeTrack.querySelectorAll('.product-layering__item')];
      if (originals.length > 1 && originals.length < 4) {
        originals.forEach(item => {
          const clone = item.cloneNode(true);
          clone.setAttribute('data-layering-clone', 'true');
          clone.setAttribute('aria-hidden', 'true');
          const content = clone.querySelector('.item__content');
          if (content) content.setAttribute('inert', '');
          blazeTrack.appendChild(clone);
        });
      }
    }
  }

  setupItemTextToggles(productLayering);

  const productLayeringItems = productLayering.querySelectorAll('.product-layering__item:not([data-layering-clone])');
  const productLayeringCount = productLayeringItems.length;

  if (productLayeringCount > 1 && productLayeringSlider) {
    const sliderInstance = new BlazeSlider(productLayeringSlider, {
      all: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        slideGap: '9px',
        loop: true,
      },
      '(min-width: 768px)': {
        slidesToShow: 2,
        slideGap: '20px',
      },
      '(min-width: 991px)': {
        slidesToShow: 3,
      },
    });

    // Hide pagination dots that correspond to the pre-cloned duplicate slides
    if (mobileQuery.matches) {
      const paginationEl = productLayeringSlider.querySelector('.blaze-pagination');
      if (paginationEl) {
        paginationEl.querySelectorAll('button').forEach((dot, i) => {
          if (i >= productLayeringCount) {
            dot.style.display = 'none';
            dot.setAttribute('aria-hidden', 'true');
          }
        });
      }

      sliderInstance.onSlide((pageIndex) => {
        const paginationEl = productLayeringSlider.querySelector('.blaze-pagination');
        if (!paginationEl) return;
        const normalized = ((pageIndex % productLayeringCount) + productLayeringCount) % productLayeringCount;
        paginationEl.querySelectorAll('button').forEach((dot, i) => {
          dot.classList.toggle('active', i === normalized);
        });
      });
    }
  }

  if (!productLayeringCount) {
    productLayering.classList.add('hidden');
  }
}
